import { T } from 'gt-react';
import { Button } from 'src/components/ui/button';
import type { GetSuggestionDetailResponse } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import { OverrideSectionFormPanel } from './OverrideSectionFormPanel';
import { useOverrideSectionController } from './useOverrideSectionController';

/**
 * Buyer override: create a custom (source:'user') option and select it. The
 * buyer picks a real location — any warehouse holding the SKU (transfer) or any
 * vendor that supplies it (buy) — from `getFulfillmentCandidates`. A transfer
 * keeps the line in its vendor cart; its transfer order is created when the
 * cart is released, once the line is approved (GEN-3023).
 */
export function OverrideSection({
  suggestion,
  side,
  highlightCartKey,
}: {
  suggestion: GetSuggestionDetailResponse;
  side?: 'buy' | 'transfer';
  highlightCartKey: string | null;
}) {
  const ctrl = useOverrideSectionController({
    suggestion,
    side,
    highlightCartKey,
  });

  if (!ctrl.open) {
    return (
      <Button variant="outline" size="sm" onClick={ctrl.openOverrideForm}>
        <T context="override button">Change source / quantity</T>
      </Button>
    );
  }

  if (ctrl.candidatesLoading) {
    return (
      <div className="space-y-3 rounded-lg border border-amber-300 bg-amber-50/40 p-4">
        <div className="py-2 text-sm text-gray-400">
          <T context="override loading candidates">Loading locations…</T>
        </div>
      </div>
    );
  }

  return <OverrideSectionFormPanel ctrl={ctrl} />;
}
